import { onboardingTheme } from './Utils/Theme';
import { activationScreens, onboardingScreens } from './Screens/OnboradingScreens';

export default function extractOnboardingJSON(configurations) {
  return {
    settings: onboardingSettings(configurations),
    theme: onboardingTheme(configurations),
    onboardingScreens: onboardingScreens(configurations),
    activationScreens: activationScreens(configurations),
  };
}

const onboardingSettings = (configurations) => {
  const res = {
    privacyUrl: configurations.onboarding.announcement.privacy_policy_link,
  };
  if (!configurations.onboarding.announcement.enable_keyboard_privacy_link) {
    delete res.privacyUrl;
  }
  return res;
};
